import { getDeviceLogTypeMeta, type DeviceLogType } from '@/entities/device-log-type-meta';
import { cn } from '@/lib/utils';

interface DeviceLogTypeBadgeProps {
	logType: DeviceLogType | string;
	className?: string;
	showIcon?: boolean;
}

export default function DeviceLogTypeBadge({ logType, className, showIcon = true }: DeviceLogTypeBadgeProps) {
	const meta = getDeviceLogTypeMeta(logType);
	const Icon = meta.icon;

	return (
		<span className={cn('inline-flex items-center gap-1 rounded-md px-1.5 py-0.5 text-xs font-semibold', meta.badgeClass, className)}>
			{showIcon ? <Icon size={12} className='shrink-0' /> : null}
			{meta.label}
		</span>
	);
}
